import {useRouter} from 'next/router';
import React from 'react';

import {Tracker} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {AlternateHeadline, CourseDirectoryWrapper} from '@udemy/react-discovery-units';
import {ExperimentImpressionEvent, useFeatures} from '@udemy/react-experimentation-provider';

import {useCertificationBrowseAggregatorContext} from '../../contexts/certification-browse-page-content-context';
import {QUICK_VIEW_BOX_FEATURE} from '../../lib/experimentation-constants';
import styles from './certification-aggregator-course-directory.module.less';

export interface CertificationAggregatorCourseDirectoryProps {
    title?: string;
}

export const CertificationAggregatorCourseDirectory = ({
    title,
}: CertificationAggregatorCourseDirectoryProps) => {
    const {gettext} = useI18n();
    const router = useRouter();
    const {featureVariantAssignments: features} = useFeatures([QUICK_VIEW_BOX_FEATURE]);
    const aggregatorContext = useCertificationBrowseAggregatorContext();
    const courseDirectoryTitle = title ?? aggregatorContext?.aggregatorContent?.aggregator_name;
    const qvbFeature = features.get(QUICK_VIEW_BOX_FEATURE);
    const fullQuickViewBoxFeature = qvbFeature?.configuration?.feature ?? false;

    /* The experiment impression event will  trigger when feature is true */
    if (qvbFeature) {
        const {experimentIds = [], isLocalDefault = false} = qvbFeature;
        Tracker.publishEvent(new ExperimentImpressionEvent(experimentIds, isLocalDefault));
    }

    return (
        <div key={`${router.asPath}-certification-aggregator-course-directory`}>
            <AlternateHeadline
                className={styles['headline-container']}
                title={interpolate(
                    gettext('All %(title)s Courses'),
                    {
                        title: courseDirectoryTitle,
                    },
                    true,
                )}
                secondaryText={interpolate(
                    gettext("Discover all of Udemy's Offerings for %(title)s"),
                    {
                        title: courseDirectoryTitle,
                    },
                    true,
                )}
            />
            <CourseDirectoryWrapper
                controlledProps={{
                    // Do not render popover on server
                    usePopover: typeof window !== 'undefined',
                    fullQuickView: fullQuickViewBoxFeature,
                }}
            />
        </div>
    );
};
